import Grid from '@mui/material/Grid';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import DatePicker from 'reservations/availabilities/components/DatePicker';
import PartySize from 'reservations/availabilities/components/PartySize';
import TimePicker from 'reservations/availabilities/components/TimePicker';
import useIsDesktop from 'reservations/base/hooks/useIsDesktop';

function MobileAvailabilitiesLayout() {
  return (
    <Grid container direction="column" rowSpacing="16px" sx={{ px: '16px' }}>
      <Grid item>
        <DatePicker />
      </Grid>
      <Grid item container direction="row" columnSpacing="8px">
        <Grid item xs={4}>
          <PartySize />
        </Grid>
        <Grid item xs={8}>
          <TimePicker />
        </Grid>
      </Grid>
    </Grid>
  );
}

function DesktopAvailabilitiesLayout() {
  return (
    <Grid container direction="row" spacing="16px" sx={{ px: '16px' }}>
      <Grid item md={3}>
        <PartySize />
      </Grid>
      <Grid item md={5}>
        <DatePicker />
      </Grid>
      <Grid item md={4}>
        <TimePicker />
      </Grid>
    </Grid>
  );
}

function AvailabilitiesConfiguration() {
  const isDesktop = useIsDesktop();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {isDesktop ? (
        <DesktopAvailabilitiesLayout />
      ) : (
        <MobileAvailabilitiesLayout />
      )}
    </LocalizationProvider>
  );
}

export default AvailabilitiesConfiguration;
